import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Icon } from '@vds/icons';
import { selectCartSummaryPrices } from '../cartSummarySelectors';
import {
  CartSummaryWrapper,
  PriceColumns,
  PriceColumn,
  PriceLabel,
  PriceValue,
  CartIconSection,
  CartIconButton,
  CartIconGlyph,
  CartBadge,
} from './CartSummary.styles';


const CartSummary = ({
  onCartIconClick,
  isCartOpen,
  displayMode,
}) => {
  const { today, monthly, savings } = useSelector(selectCartSummaryPrices);

  return (
    <CartSummaryWrapper displayMode={displayMode} data-testid="cart-summary">
      <PriceColumns displayMode={displayMode}>
        <PriceColumn>
          <PriceLabel>Today</PriceLabel>
          <PriceValue data-testid="cart-summary-today">${Number(today).toFixed(2)}</PriceValue>
        </PriceColumn>

        <PriceColumn>
          <PriceLabel>Monthly</PriceLabel>
          <PriceValue data-testid="cart-summary-monthly">${Number(monthly).toFixed(2)}</PriceValue>
        </PriceColumn>

        {Number(savings) > 0 && (
          <PriceColumn>
            <PriceLabel isSavings>Savings</PriceLabel>
            <PriceValue isSavings data-testid="cart-summary-savings">
              ${Number(savings).toFixed(2)}
            </PriceValue>
          </PriceColumn>
        )}
      </PriceColumns>

      <CartIconSection>
        <CartIconButton
          type="button"
          onClick={onCartIconClick}
          aria-label={isCartOpen ? 'Close cart summary' : 'Open cart summary'}
          aria-expanded={isCartOpen}
          aria-haspopup="dialog"
          data-testid="cart-icon-button"
          data-track={JSON.stringify({ type: 'link', name: 'cart icon_click' })}
        >
          <CartIconGlyph>
            <Icon name="shopping" size="large" color="#000000" ariaHidden />
            <CartBadge data-testid="cart-icon-badge" aria-hidden="true" />
          </CartIconGlyph>
        </CartIconButton>
      </CartIconSection>
    </CartSummaryWrapper>
  );
};

CartSummary.propTypes = {
  onCartIconClick: PropTypes.func.isRequired,
  isCartOpen: PropTypes.bool.isRequired,
  displayMode: PropTypes.oneOf(['desktop', 'mobile']),
};

CartSummary.defaultProps = {
  displayMode: 'desktop',
};

export default CartSummary;
